module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-004.10be144f.jpg";